import React, { useState,useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { fetch_member_communication_data } from '../../../services/mtp/Service';
import { LoaderLoader } from '../../utils/CommonLibrary';

function MemberCommunicationsTable() {
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedChannel, setSelectedChannel] = useState('All');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [communicationData, setCommunicationData] = useState([]);
    const [communicationMessage, setCommunicationMessage] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


useEffect(() => {
        fetchMemberCommunicationData();
},[]);


const fetchMemberCommunicationData = async () => {
    try {
        setIsLoading(true); // show loader
        let response = await fetch_member_communication_data();
        if(response.data.code === 200){
            setCommunicationData(response.data.data || []);
        }
        setIsLoading(false); // hide loader
    } catch (error) {
      console.error(error);
    }
};
    const columns = [
        {
            name: 'Member ID',
            selector: row => row.communicationId,
            sortable: true,
        },
        {
            name: 'Member Name',
            selector: row => row.memberName,
            sortable: true,
        },
        {
            name: 'Communication message',
            selector: row => row.communination,
            sortable: true,
        },
        {
            name: 'Sent Date',
            selector: row => row.DeliveredDate,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            cell: row => (
                <span style={{ color: row.status === 'Delivered' ? '#01CD88' : '#FF0000' }}>
                    {row.status}
                </span>
            ),
        },
        {
            name: 'Communication Channel',
            selector: row => row.communicationType,
            sortable: true,
        },
    ];
    const data = communicationData;

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#D4E6EF',
                fontWeight: '500',
                fontSize: '14px',
                whiteSpace: 'normal',
            },
        },
        rows: {
            style: {
                whiteSpace: 'normal',
            },
        },
        cells: {
            style: {
                whiteSpace: 'normal',
            },
        },
    };

    const handleClear = () => {
        setSearchQuery('');
        setSelectedChannel('All');
        setSelectedStatus('All');
    };
    
    const filteredData = data.filter(item => {
        const matchesSearchQuery = 
            // item.communicationId.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.memberName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.communination.toLowerCase().includes(searchQuery.toLowerCase());

        const matchesChannel = selectedChannel === 'All' || item.communicationType === selectedChannel;
        const matchesStatus = selectedStatus === 'All' || item.status === selectedStatus;

        return matchesSearchQuery && matchesChannel && matchesStatus;
    });

    return (
        <>
            <LoaderLoader isLoading={isLoading} />
           
            <div className='container-fluid'>
                
                <div className='row mb-3'>
                    
                    <div className='col-md d-flex px-1'>
                    <div className="form-group" style={{width: "100%"}}>
                        <input
                            type="text"
                            placeholder="Search By Member Name or Member ID"
                            value={searchQuery}
                            onChange={e => setSearchQuery(e.target.value)}
                            className="form-control input-field-ui ps-5"
                        />
                        <img src={require("../../../images/icon-search.png")} className="input-icon-seacrh" alt="" />
                        </div>
                    </div>
                    <div className='col-md-3 px-1'>
                        <select
                            value={selectedStatus}
                            onChange={e => setSelectedStatus(e.target.value)}
                            className='form-select input-field-ui'
                        >
                            <option value="All">--Select Status--</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Undelivered">Undelivered</option>
                        </select>
                    </div>
                    <div className='col-md-3 px-1'>
                        <select
                            value={selectedChannel}
                            onChange={e => setSelectedChannel(e.target.value)}
                            className='form-select input-field-ui'
                        >
                            <option value="All">--Select Communication--</option>
                            <option value="Whatsapp">Whatsapp</option>
                            <option value="SMS">SMS</option>
                            <option value="Push Notification">Push Notification</option>
                            <option value="Email">Email</option>
                        </select>
                    </div>
                    <div className='col-md-auto px-1'>
                        <button onClick={handleClear} className='btn btn-primary btn-primary clear-search-btn'>Clear</button>
                    </div>
                </div>
            </div>
            {communicationData === 0 ? <div>{communicationMessage}</div> :
            (<>
            <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationPerPage={5}
                striped
                responsive
                noHeader
                noFooter
                customStyles={customStyles}
            />
            </>
            )}
        </>
    );
}

export default MemberCommunicationsTable;
